import { UseFeatureFlagTranslatedPayloadProps } from 'hooks/types'
import { useRouter } from 'next/router'
import { useFeatureFlagEnabled, useFeatureFlagPayload, useFeatureFlagVariantKey } from 'posthog-js/react'
import { IS_PROD } from 'constants/envs'

export const useFeatureFlagTranslatedPayload = ({ key, fallback, debug }: UseFeatureFlagTranslatedPayloadProps): string => {
  // Router
  const { locale } = useRouter()

  // Posthog
  const flagPayload = useFeatureFlagPayload(key)
  const flagVariant = useFeatureFlagVariantKey(key)
  const flagEnabled = useFeatureFlagEnabled(key)

  if (debug && !IS_PROD) {
    console.log(`Feature Flag: ${key}`, {
      flagPayload,
      flagVariant,
      flagEnabled,
      locale
    })
  }

  // Return the translated payload if it exists, otherwise return the fallback
  return flagPayload && typeof flagPayload === 'object' && locale in flagPayload ? flagPayload[locale] : fallback
}
